import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Calendar } from 'primeng/calendar';

import { EnvironmentService } from '@core/services';
import { randomId } from '@util/random-id';

@Component({
  selector: 'z-date',
  templateUrl: './date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<boolean>();

  @Input() fieldName: string;

  @Input() readonly: boolean = false;
  @Input() disabled: boolean = false;
  @Input() uppercase: boolean = false;

  @Input() clearButton: boolean = false;
  @Input() matchTypes: boolean = false;
  @Input() manualInput: boolean = true;

  @Input() id: string;
  @Input() label: string;
  @Input() hint: string;
  @Input() placeholder: string;

  @Input() displayValidationErrors: boolean = true;
  @Input() hideLabel: boolean = false;

  @Input() multipleSeparator: string = ',';
  @Input() rangeSeparator: string = '-';

  @Input() showTime: boolean = false;
  @Input() timeOnly: boolean = false;
  @Input() showSeconds: boolean = false;

  @Input() appendTo?: string = 'body';

  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() disabledDates: Date[];
  @Input() disabledDays: number[];

  @Input() maxDateCount: number;
  @Input() showButtonBar: boolean = true;
  @Input() showOnFocus: boolean = true;

  @Input() selectionMode: string = 'single';

  @Input() dateFormat: string = this.environmentService.primeNgDateLongFormat;
  @Input() hourFormat: string = this.environmentService.primeNgTime12Format;

  @Output() change = new EventEmitter<Date | Date[]>();
  @Output() clear = new EventEmitter<void>();
  @Output() matchTypeChange = new EventEmitter<string>();

  elementId: string;

  firstDayOfWeek: number = 1;
  showClearButton: boolean = false;

  @ViewChild('calendar') calendar: Calendar;

  constructor(public formGroup: FormGroupDirective, private environmentService: EnvironmentService) {}

  ngOnInit() {
    if (this.id) {
      this.elementId = this.id;
    } else {
      this.elementId = `z-date-${randomId()}`;
    }

    const field$ = this.formGroup.form.get(this.fieldName).valueChanges;

    field$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.change.emit(value);

      if (!value) {
        this.showClearButton = false;
      } else {
        this.showClearButton = true;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  update() {
    this.calendar.cd.detectChanges();
  }

  onClearClick(_event: any) {
    this.formGroup.form.get(this.fieldName).setValue(null);
    this.clear.emit();
  }

  onMatchTypeChange(event: any) {
    this.matchTypeChange.emit(event);
  }

  onSelect(_event: any) {
    // console.log('onSelect:', event);
  }

  onBlur(_event: any) {
    // console.log('onBlur:', event);
  }

  onFocus(_event: any) {
    // console.log('onFocus:', event);
  }

  onClose(_event: any) {
    // console.log('onClose:', event);
  }

  onShow(_event: any) {
    // console.log('onShow:', event);
  }

  onClickOutside(_event: any) {
    // console.log('onClickOutside:', event);
  }

  onInput(_event: any) {
    // console.log('onInput:', event);
  }

  onTodayClick(_event: any) {
    // console.log('onTodayClick:', event);
  }

  onCalendarClearClick(_event: any) {
    // console.log('onCalendarClearClick:', event);
  }

  onMonthChange(_event: any) {
    // console.log('onMonthChange:', event);
  }

  onYearChange(_event: any) {
    // console.log('onYearChange:', event);
  }
}
